<template>
  <div>
    <canvas ref="barChart" style="width: 100%; height: 100%;"></canvas>
  </div>
</template>

<script>
import { Chart } from 'chart.js/auto';
import axios from 'axios';

export default {
  name: 'BarChart',
  data() {
    return {
      chart: null,
      dates: [],
      totalAssets: [],
      activeAssets: [],
      inactiveAssets: [],
      highTempAssets: [],
      lowTempAssets: [],
      lowBatteryAssets: []
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await axios.get('/api/dashboard_7days');
        const data = response.data;

        // 날짜별 데이터 설정
        data.forEach((day) => {
          this.dates.push(this.formatDateTime(day.date)); // 날짜 포맷 적용
          this.totalAssets.push(day.totalAssets);
          this.activeAssets.push(day.activeAssets);
          this.inactiveAssets.push(day.inactiveAssets);
          this.highTempAssets.push(day.highTempAssets);
          this.lowTempAssets.push(day.lowTempAssets);
          this.lowBatteryAssets.push(day.lowBatteryAssets);
        });

        // 차트 생성
        this.renderChart();
      } catch (error) {
        console.error('Failed to fetch data for BarChart:', error);
      }
    },
    formatDateTime(dateTime) {
      const date = new Date(dateTime);
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      };
      return date.toLocaleString('en-US', options);
    },
    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.barChart.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.dates,
          datasets: [
            {
              label: 'Total Assets',
              backgroundColor: '#f2a623',
              data: this.totalAssets
            },
            {
              label: 'Active Assets',
              backgroundColor: '#008000',
              data: this.activeAssets
            },
            {
              label: 'Inactive Assets',
              backgroundColor: '#ca1305',
              data: this.inactiveAssets
            },
            {
              label: 'High Temperature',
              backgroundColor: '#4a90e2',
              data: this.highTempAssets
            },
            {
              label: 'Low Temperature',
              backgroundColor: '#50e3c2',
              data: this.lowTempAssets
            },
            {
              label: 'Low Battery',
              backgroundColor: '#9013fe',
              data: this.lowBatteryAssets
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'top'
            }
          },
          scales: {
            x: {
              title: {
                display: true,
                text: 'Date'
              }
            },
            y: {
              beginAtZero: false,
              title: {
                display: true,
                text: 'Count'
              }
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped>
#barChart {
  max-width: 100%;
  max-height: 100%;
}
</style>
